export enum CompanyType {
  HostedCompany = 'H',
  Mars = 'M',
  RequestorCompany = 'R',
}
